// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3SJJg","title":"Images45_title___OHqd","images":"Images45_images__1FTxy"};